
import { Component, Vue } from 'vue-property-decorator'
import { getOperationLogPage, IAdminOperationLog } from '@/api/operationLog'

/**
 * 侧栏「操作日志」默认隐藏。控制台开关（刷新后生效）：
 *   localStorage.setItem('adminShowOperationLog', '1')  // 显示
 *   localStorage.setItem('adminShowOperationLog', '0')  // 隐藏
 */
@Component({ name: 'OperationLog' })
export default class extends Vue {
  private loading = false
  private list: IAdminOperationLog[] = []
  private total = 0
  private detailVisible = false
  private current: IAdminOperationLog | null = null

  private query = {
    pageNum: 1,
    pageSize: 10,
    operatorKeyword: '',
    keyword: '',
    success: null as number | null
  }

  mounted() {
    this.loadList()
  }

  private async loadList() {
    this.loading = true
    try {
      const params: any = {
        pageNum: this.query.pageNum,
        pageSize: this.query.pageSize
      }
      if (this.query.operatorKeyword) params.operatorKeyword = this.query.operatorKeyword.trim()
      if (this.query.keyword) params.keyword = this.query.keyword.trim()
      if (this.query.success != null) params.success = this.query.success

      const res: any = await getOperationLogPage(params)
      if (String(res.data.code) === '1' && res.data.data) {
        this.list = res.data.data.records || []
        this.total = res.data.data.total || 0
      } else {
        this.list = []
        this.total = 0
      }
    } catch (e) {
      this.list = []
      this.total = 0
    } finally {
      this.loading = false
    }
  }

  private tableIndex(index: number) {
    return (this.query.pageNum - 1) * this.query.pageSize + index + 1
  }

  private handleSearch() {
    this.query.pageNum = 1
    this.loadList()
  }

  private handleReset() {
    this.query.operatorKeyword = ''
    this.query.keyword = ''
    this.query.success = null
    this.query.pageNum = 1
    this.loadList()
  }

  private handleSizeChange(size: number) {
    this.query.pageSize = size
    this.loadList()
  }

  private handlePageChange(page: number) {
    this.query.pageNum = page
    this.loadList()
  }

  private showDetail(row: IAdminOperationLog) {
    this.current = row
    this.detailVisible = true
  }

  private roleLabel(role?: number) {
    if (role === 0) return '超级管理员'
    if (role === 2) return '派送员'
    if (role === 1) return '店长'
    return '—'
  }

  private formatDate(val?: string) {
    if (!val) return '-'
    return String(val).replace('T', ' ').substring(0, 19)
  }
}
